import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class Skeleton extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'skeleton')
    
    this.maxHealth = 30
    this.health = 30
    this.damage = PLAYER_DAMAGE.LIGHT
    this.moveSpeed = 3.5
    this.attackRange = 4 // Close enough to pressure the player before shooting
    this.attackCooldown = 5
    this.detectionRange = 18
    
    this.projectiles = []
  }
  
  attack() {
    const player = this.game.player
    if (!player) return
    
    // Calculate direction to player
    const dx = player.x - this.x
    const dy = player.y - this.y
    const dist = Math.sqrt(dx * dx + dy * dy)
    
    if (dist > 0) {
      const dirX = dx / dist
      const dirY = dy / dist
      
      this.projectiles.push({
        x: this.x,
        y: this.y,
        dirX,
        dirY,
        speed: 10,
        lifetime: 3
      })
    }
  }
  
  update(delta) {
    super.update(delta)
    
    // Update projectiles
    for (let i = this.projectiles.length - 1; i >= 0; i--) {
      const proj = this.projectiles[i]
      
      proj.x += proj.dirX * proj.speed * delta
      proj.y += proj.dirY * proj.speed * delta
      proj.lifetime -= delta
      
      // Check hit player
      const dx = proj.x - this.game.player.x
      const dy = proj.y - this.game.player.y
      const dist = Math.sqrt(dx * dx + dy * dy)
      
      if (dist < 0.5) {
        const actualDamage = this.damage * this.damageMultiplier
        this.game.player.takeDamage(actualDamage)
        this.projectiles.splice(i, 1)
        continue
      }
      
      // Remove expired or if hit wall
      if (proj.lifetime <= 0 || this.game.world.isSolid(proj.x, proj.y)) {
        this.projectiles.splice(i, 1)
      }
    }
  }
  
  render(renderer) {
    super.render(renderer)
    
    // Render projectiles
    for (const proj of this.projectiles) {
      renderer.fillCircle(proj.x, proj.y, 0.15, '#f5f5dc')
    }
  }
  
  die() {
    this.projectiles = []
    super.die()
  }
  
  dropLoot() {
    if (Math.random() < 0.25) {
      this.game.itemManager.spawnItem({
        type: 'heart',
        id: 'heart',
        name: 'Heart',
        count: 1
      }, { x: this.x, y: this.y })
    }
  }
}
